import { routes } from '@routes';

export const getOrganizationHomePath = (organizationSlug?: string): string =>
  organizationSlug ? routes.dashboard.make(organizationSlug) : routes.organizationsList.make();
